module.exports = __webpack_public_path__ + "media/images/master_favicon-a520911d6db18992136ae9b4cdea1169.png";